import { Claim } from "./Models/Claim";
class Server {
	//window["apiAddress"] || window["emanagerBaseApiAddress"];
	private apiAddressV1: string = window["apiAddress"] || window["emanagerBaseApiAddress"];
	private websiteId: string = window["websiteId"];
	private requestsInFlight: { [key: string]: Promise<Response> } = {};

	protected parseCookie(name:string)
	{
		var nameEq = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEq) === 0) {
                return c.substring(nameEq.length, c.length);
            }
        }
        return null;
	}

	protected setCookie(name:string, value:string)
	{
		var date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + value + expires + "; path=/";
	}

	private ensureUrls()
	{
		if (!this.apiAddressV1)
			this.apiAddressV1 = window["apiAddress"] || window["emanagerBaseApiAddress"];
		if (!this.websiteId)
			this.websiteId = window["websiteId"];
	}

	protected internalBuildUrlV1(action: string) {
		this.ensureUrls();
		if (this.apiAddressV1.indexOf("api/v1/") === -1)
		{
			return `${this.apiAddressV1}api/v1/website/${this.websiteId}/${action}`;
		}
		return `${this.apiAddressV1}website/${this.websiteId}/${action}`;
	}

	protected internalRecordidUrl()
	{
		this.ensureUrls();
		if (this.apiAddressV1.indexOf("api/v1/") === -1)
		{
			return `${this.apiAddressV1}api/v1/recordidgenerator`;
		}
		return `${this.apiAddressV1}recordidgenerator`;
	}

	public getRecordId(cancelPreviousRequestKey: string | null = null)
	{
		const url = this.internalRecordidUrl()
		const request: RequestInit = {
			method: "GET",
			headers: new Headers({
				Accept: "application/json",
				"Content-Type": "application/json",
			}),
			mode: "no-cors",
			redirect: "follow"
		};
		const xhr = fetch(url, request).then((response: Response) => {
			this.removeRequestInFlight(cancelPreviousRequestKey);
			return response;
		});
		if (cancelPreviousRequestKey) {
			this.requestsInFlight[cancelPreviousRequestKey] = xhr;
		}
		return xhr;
	}

	public sendCommand(
		urlFragment: string,
		method: string | "GET" | "PATCH" | "PUT" | "POST" | "DELETE" = "POST",
		command: any = null,
		cancelPreviousRequestKey: string | null = null,
		isFormData: boolean = false
	) {
		const url = `${
 			this.internalBuildUrlV1(urlFragment)
			}`;
		const isForm = typeof command === "string" || isFormData;
		const request: RequestInit = {
			method: method,
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
            },
            mode: "cors",
			body: isForm ? (isFormData ? this.turnIntoFormData(command) : command) : command ? JSON.stringify(command) : null,
		};
		if (method === "GET") {
			delete request.body;
		}
		const xhr = fetch(url, request).then((response: Response) => {
			this.removeRequestInFlight(cancelPreviousRequestKey);
			return response;
		}).catch((response: Response) => {
			this.removeRequestInFlight(cancelPreviousRequestKey);
			return response;
		});
		if (cancelPreviousRequestKey) {
			this.requestsInFlight[cancelPreviousRequestKey] = xhr;
		}
		return xhr;
	}

	public sendClaim(
		claim: Claim,
		files: File[],
		urlFragment: string,
		updateProgess:(progress: number) => void
	): Promise<string>
	{
		let promise = new Promise<string>((done, reject) =>
		{
			const tick = new Date().getTime() * 10000 + 621355968000000000;
			let url =
				this.internalBuildUrlV1(urlFragment);
			let xhr = new XMLHttpRequest();
			xhr.open("POST", url, true);
			xhr.withCredentials = true;
			let form = new FormData();
			form.append("claim", JSON.stringify(claim));
			for(let i = 0; i< files.length;i++)
			{
				form.append(files[i].name,files[i], files[i].name);
			}
			xhr.onreadystatechange = (event: Event) =>
			{
				if (xhr.readyState === 4)
				{
					done(xhr.response as string);
					reject(xhr.response);
				}
			};
			xhr.upload.addEventListener("progress", function (evt) {
				if (evt.lengthComputable) {
					updateProgess(Math.round(100* (evt.loaded / evt.total)));
				}
			  }, false);
			/*xhr.onprogress = (progress: ProgressEvent) =>{
				updateProgess(Math.round((100 * progress.loaded) / progress.total));
			};*/
			xhr.send(form);
		});

		return promise;
	}

	private turnIntoFormData(command: any)
	{
		let urlEncodedData = "",
			urlEncodedDataPairs = [] as any,
			name;

		// Turn the data object into an array of URL-encoded key/value pairs.
		for( name in command ) {
			urlEncodedDataPairs.push( encodeURIComponent( name) + '=' + encodeURIComponent( command[name]) as any );
		}

		// Combine the pairs into a single string and replace all %-encoded spaces to 
		// the '+' character; matches the behaviour of browser form submissions.
		urlEncodedData = urlEncodedDataPairs.join( '&' ).replace( /%20/g, '+' );
		return urlEncodedData;
	}

	//I added async and await to this
	private async removeRequestInFlight(key: string | null) {
		if (key) {
			const request = this.requestsInFlight[key];
			if (await request) {
				delete this.requestsInFlight[key];
			}
		}
	}

	protected uriEncodeObj(obj: any): string {
		const encoded: string[] = [];
		// ReSharper disable once MissingHasOwnPropertyInForeach
		for (let property in obj) {
			const key = encodeURIComponent(property);
			const value = encodeURIComponent(obj[property]);
			encoded.push(`${key}=${value}`);
		}
		const serialized = encoded.join("&");
		return serialized;
	}
}

export default new Server();
